module.exports = __webpack_public_path__ + "static/ambient-2e2824790dc00d921ba19e9ca7c68eae.wav";